import Kotlin from './Kotlin.svg';
import Mendix from './mendix-logo-1.svg';
import Java from './java-svgrepo-com.svg';
import Python from './python-svgrepo-com.svg';
import CPlusPlus from './C++ (CPlusPlus).svg';
import CSharp from './Csharp.svg';
import JavaScript from './js-svgrepo-com.svg';
import PHP from './php-svgrepo-com.svg';
import Swift from './swift-16-svgrepo-com.svg';
import TypeScript from './TypeScript.svg';
import Ruby from './Ruby.svg';
import Flutter from './flutter-svgrepo-com.svg';
import ReactNative from './react-native.svg';
import React from './react.svg';
import iOSSDK from './open-sdk-download.svg';
import AndroidSDK from './android-sdk.svg';
import Dart from './Dart.svg';
import Rust from './rust-svgrepo-com.svg';
import Unity from './unity-svgrepo-com.svg';
import Firebase from './Firebase.svg';
import Xamarin from './Xamarin.svg';
import NET from './NET.svg';
import Angular from './angular-svgrepo-com.svg';
import Django from './django-icon.svg';
import Supabase from './supabase-logo-DCC676FFE2-seeklogo.com.svg';
import SupabaseLogo from './supabase.svg';
import Spring from './spring-svgrepo-com.svg';
import Ktor from './Ktor.svg';
import NodeJS from './nodejs-icon 1.svg';
import Figma from './figma-svgrepo-com.svg';
import Blender from './blender-1.svg';
import Maui from './maui.svg';
import KeyCloakOAuth from './KeycloakOauth.svg';
import ThirdPartyWeb from './api-svgrepo-com (2).svg';
import ThirdPartyAPI from './api-svgrepo-com (3).svg';
import WEB3API from './api-1-svgrepo-com.svg';
import Tizen from './tizen-logo.svg';
import Ios from './ios.svg';
import NodejsPlatform from './nodejs-platform.svg';
import ObjectiveC from './objectiveC.svg';
import Ionic from './ionic.svg';
import FlutterFlow from './flutter-flow.svg';
import Cordova from './cordova.svg';
import ARKit from './ARKit.svg';
import VisionOS from './vision-os.svg';
import CarPlay from './car-play.svg';
import AndroidAuto from './android-auto.svg';
import WatchOS from './watch-os.svg';
import WearOS from './wear-os.svg';
import AndroidTV from './android-tv.svg';
import HealthConnect from './health-connect.svg';
import NFC from './nfc.svg';
import Bluetooth from './ble.svg';
import GPS from './gps.svg';
import ApplePay from './apple-pay.svg';
import GooglePay from './google-pay.svg';
import InAppPurchases from './in-app-purchases.svg';
import Serverpod from './serverpod.svg';
import Cube from './cube-with-layers.svg';

export const techIconMap: Record<string, string> = {
  Mendix,
  AndroidAuto,
  WatchOS,
  'Watch OS': WatchOS,
  WearOS,
  'Wear OS': WearOS,
  VisionOS,
  'Vision OS': VisionOS,
  AndroidTV,
  'Android TV': AndroidTV,
  HealthConnect,
  NFC,
  Bluetooth,
  BLE: Bluetooth,
  GPS,
  ApplePay,
  GooglePay,
  InAppPurchases,
  ARKit,
  CarPlay,
  Java,
  FlutterFlow,
  'Flutter Flow': FlutterFlow,
  Ionic,
  ObjectiveC,
  'Objective-C': ObjectiveC,
  Python,
  Cordova,
  'C++': CPlusPlus,
  'C#': CSharp,
  JavaScript,
  PHP,
  Kotlin,
  Swift,
  TypeScript,
  Ruby,
  Flutter,
  ReactNative,
  'React Native': ReactNative,
  Ios,
  'iOS SDK': iOSSDK,
  'Android SDK': AndroidSDK,
  Dart,
  React,
  NodejsPlatform,
  Rust,
  Maui,
  Unity,
  Firebase,
  Xamarin,
  '.NET': NET,
  Angular,
  SupabaseLogo,
  Tizen,
  'Tizen SDK': Tizen,
  Django,
  'Third-party web3': ThirdPartyWeb,
  'Third-Party API': ThirdPartyAPI,
  'web3 API': WEB3API,
  Supabase,
  Spring,
  Ktor,
  'Node.js': NodeJS,
  Figma,
  Blender,
  KeyCloakOAuth,
  'Keycloak OAuth': KeyCloakOAuth,
  'KeyCloak OAuth': KeyCloakOAuth,
  Serverpod,
  default: Cube,
};
